import type { TableProps } from "@hightouch/formkit";
import { Controller } from "react-hook-form";
import { TunnelTable } from "src/components/destinations/tunnel-table";
import type { SharedProps } from ".";

export const FKTunnelTable = ({
  name,
  columns,
  addRow,
  addRowLabel,
  createTunnel,
  isDisabled,
}: TableProps & SharedProps) => (
  <Controller
    name={name}
    render={({ field }) => (
      <TunnelTable
        isDisabled={isDisabled}
        addRow={addRow}
        addRowLabel={addRowLabel}
        createTunnel={createTunnel}
        columns={columns}
        value={field.value}
        onChange={field.onChange}
      />
    )}
  />
);
